import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronLeft, ChevronRight, Quote } from "lucide-react";
import { TESTIMONIALS } from "@/lib/brand";

export default function Testimonials() {
  const [idx, setIdx] = useState(0);
  const t = TESTIMONIALS[idx];

  const go = (dir) => {
    setIdx((p) => (p + dir + TESTIMONIALS.length) % TESTIMONIALS.length);
  };

  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative py-24 md:py-32"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-24 grid lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-4">
          <span className="inline-flex items-center gap-2 text-sm font-medium text-[#00A65A]">
            <span className="w-6 h-px bg-[#00A65A]" />
            Client voices
          </span>
          <h2 className="mt-3 font-display text-4xl md:text-5xl lg:text-6xl font-medium tracking-tight text-[#0B1B3D] leading-[1.04]">
            What families <span className="italic font-light text-[#00A65A]">say.</span>
          </h2>
          <p className="mt-5 text-[#0B1B3D]/70">
            Real stories from real Indian investors — across professions, ages, and dreams.
          </p>

          <div className="mt-10 flex items-center gap-3">
            <button
              data-testid="testimonial-prev"
              onClick={() => go(-1)}
              className="w-12 h-12 rounded-full border border-[#0B1B3D]/20 flex items-center justify-center hover:bg-[#0B1B3D] hover:text-white hover:border-[#0B1B3D] transition-all"
              aria-label="Previous testimonial"
            >
              <ChevronLeft className="w-5 h-5" />
            </button>
            <button
              data-testid="testimonial-next"
              onClick={() => go(1)}
              className="w-12 h-12 rounded-full bg-[#0B1B3D] text-white flex items-center justify-center hover:bg-[#00A65A] transition-all"
              aria-label="Next testimonial"
            >
              <ChevronRight className="w-5 h-5" />
            </button>
            <span className="font-mono text-sm text-[#0B1B3D]/50 ml-3">
              {String(idx + 1).padStart(2, "0")} / {String(TESTIMONIALS.length).padStart(2, "0")}
            </span>
          </div>
        </div>

        <div className="lg:col-span-8 relative min-h-[320px]">
          <Quote className="absolute -top-4 -left-2 w-24 h-24 text-[#00A65A]/15" />
          <AnimatePresence mode="wait">
            <motion.div
              key={t.name}
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -16 }}
              transition={{ duration: 0.5 }}
              className="relative"
            >
              <p
                data-testid="testimonial-quote"
                className="font-display italic text-2xl md:text-3xl lg:text-4xl text-[#0B1B3D] leading-snug font-light"
              >
                "{t.quote}"
              </p>
              <div className="mt-8 flex items-center gap-4">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#0B1B3D] to-[#00A65A] flex items-center justify-center text-white font-display text-xl font-medium">
                  {t.name.charAt(0)}
                </div>
                <div>
                  <div className="font-medium text-[#0B1B3D]">{t.name}</div>
                  <div className="text-sm text-[#0B1B3D]/60">{t.role}</div>
                </div>
              </div>
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </section>
  );
}
